"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NpcManager = void 0;
const VariableStore_1 = require("./VariableStore");
const npcCharacter_1 = require("../utils/npcCharacter");
/**
 * Tracks which NPCs are active (non-empty `character_location`) using the shared VariableStore.
 * Does not duplicate location or other state — reads/writes `character_location` per character name.
 */
class NpcManager {
    constructor(variableStore, getAdventure, getAnchorContext, onWorldLocationChange) {
        this.variableStore = variableStore;
        this.getAdventure = getAdventure;
        this.getAnchorContext = getAnchorContext;
        this.onWorldLocationChange = onWorldLocationChange;
    }
    npcContextFor(characterName) {
        const anchor = this.getAnchorContext();
        return VariableStore_1.VariableStore.buildVariableContext(anchor.playerId, characterName, anchor.currentSceneId, anchor.userId);
    }
    /**
     * NPC character names that currently have a non-empty `character_location` (only definitions that qualify as NPCs).
     */
    getActiveNpcIds() {
        const adventure = this.getAdventure();
        if (!adventure)
            return [];
        const active = [];
        for (const def of adventure.getNpcDefinitions()) {
            const loc = this.getWorldLocationForNpc(def.name);
            if (loc !== '') {
                active.push(def.name);
            }
        }
        return active.sort((a, b) => a.localeCompare(b));
    }
    /** Normalized world `character_location` for an NPC character id, or empty string if dormant / unknown. */
    getWorldLocationForNpc(characterId) {
        const adventure = this.getAdventure();
        const character = adventure?.getCharacter(characterId);
        if (character !== undefined && !(0, npcCharacter_1.isNpcDefinition)(character)) {
            return '';
        }
        const v = this.variableStore.getVariable('character_location', this.npcContextFor(characterId));
        if (v === undefined || v === null) {
            return '';
        }
        const s = String(v).trim();
        return s;
    }
    spawnNpc(id, location) {
        this.setNpcLocation(id, location);
    }
    despawnNpc(id) {
        this.setNpcLocation(id, null);
    }
    /**
     * Sets or clears the NPC's world location (`character_location`). Empty string or null deactivates the NPC.
     */
    setNpcLocation(id, location) {
        const adventure = this.getAdventure();
        const character = adventure?.getCharacter(id);
        if (character !== undefined && !(0, npcCharacter_1.isNpcDefinition)(character)) {
            console.warn(`[NpcManager] setNpcLocation('${id}'): character is not an NPC definition (isNpc / update script). Skipping.`);
            return;
        }
        const previous = this.getWorldLocationForNpc(id);
        const value = location == null || location === '' ? '' : String(location);
        this.variableStore.setVariable('character_location', value, this.npcContextFor(id), 'string');
        const next = this.getWorldLocationForNpc(id);
        if (previous !== next) {
            try {
                this.onWorldLocationChange?.(id, previous, next);
            }
            catch {
                /* ignore observer errors */
            }
        }
    }
}
exports.NpcManager = NpcManager;
//# sourceMappingURL=NpcManager.js.map